import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const HeaderStyled = styled.div`
  position: sticky;
  top: 0;
  z-index: 1000;

  .heading {
    font-weight: bold;
    font-size: 20px;
  }
  .navbar {
    position: sticky;
    top: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    background-color: #fff;
    padding: 0 36px;
    border-bottom: 1px solid ${COLOUR_CONSTANT.theme.lightPink};
  }

  .routes-menu-wrapper {
    display: flex;
    gap: 40px;
    justify-content: center;
    height: 100%;
  }
  .logo-container {
    flex: 0 0 auto;
    margin-right: 20px;
    cursor: pointer;
  }
  .logo {
    height: 30px;
  }

  .routes {
    display: flex;
    height: 100%;
    /* gap: 17px; */

    .route-style {
      height: 100%;
      display: flex;
      align-items: center;
    }
    .active {
      border-bottom: 2px solid #301d35 !important;
    }
    .transparent-border {
      /* width: 100px; */
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 2px solid transparent;
      /* background-color: red; */
    }
    .menu-icon {
      width: auto;
      color: #301d35;
      font-size: 14px;
      font-weight: 400;
      margin-left: 0px;
      :hover {
        cursor: pointer;
      }
    }
  }

  .avatar-menu {
    display: flex;
    align-items: center;
    .avatar-style {
      color: white;
      background: #301d35;
      font-weight: bold;
    }
  }

  .tab-content {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  .MuiButtonBase-root {
    height: 60px !important;
  }
`;
